var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cookie-law',{attrs:{"buttonText":"Chiudi","message":"www.puntohomeimmobiliare.it utilizza solo cookie tecnici necessari alla navigazione.","theme":"dark-lime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }